import './App.css';
import Home from './Component/Home';


function App() {
  return (
    <div className="App">
       <div class="Author">&#60;Ashutosh Verma/&#62;</div>
      <Home/>
    </div>
  );
}

export default App;
